var ShippingSummarySlotTypes;
(function(ShippingSummarySlotTypes) {
    ShippingSummarySlotTypes["Addresses"] = 'addresses';
    ShippingSummarySlotTypes["ContactDetails"] = 'contactDetails';
    ShippingSummarySlotTypes["Company"] = 'company';
    ShippingSummarySlotTypes["Invoice"] = 'invoice';
    ShippingSummarySlotTypes["ExpressCheckout"] = 'expressCheckout';
})(ShippingSummarySlotTypes || (ShippingSummarySlotTypes = {}));

export { ShippingSummarySlotTypes };
//# sourceMappingURL=types.js.map
